angular.module('impactx.search').controller('SearchListProductGroupCtrl', SearchListProductGroupCtrl);
SearchListProductGroupCtrl.$inject = [
    '$scope',
    'AppConfiguration',
    'dataGen',
    'ToolbarService',
    '$routeParams'
];

function SearchListProductGroupCtrl($scope, AppConfiguration, dataGen, ToolbarService, $routeParams) {
    var self = this;

    $scope.search = function () {
        return dataGen.getData($scope, {id: $routeParams.id, prgId: $routeParams.prgId}, "/vcatalog/subproductgroups").then(function (result) {
            $scope.data = result.data.searchResult;
            $scope.showAsList = result.data.showAsList;
            $scope.trns = result.trns;
        })
    };
    $scope.search();

    self.displayAllResultsAsList = function () {
        return AppConfiguration.get('displayAllResultsAsList') || $scope.showAsList;
    };

    ToolbarService.setButtons([]);
}
